import "./async.js";
import { c as attr_class, b as escape_html } from "./renderer.js";
function Modal($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { show = false, onclose, title, wide = false, children, footer } = $$props;
    if (show) {
      $$renderer2.push("<!--[0-->");
      $$renderer2.push(`<div class="modal-overlay"><div${attr_class("modal svelte-ta60gp", void 0, { "modal-wide": wide })}>`);
      if (title) {
        $$renderer2.push("<!--[0-->");
        $$renderer2.push(`<div class="modal-header svelte-ta60gp"><h3 style="color: var(--text);" class="svelte-ta60gp">${escape_html(title)}</h3></div>`);
      } else {
        $$renderer2.push("<!--[-1-->");
      }
      $$renderer2.push(`<!--]--> <div class="modal-body" style="color: var(--text);">`);
      children?.($$renderer2);
      $$renderer2.push(`<!----></div> `);
      if (footer) {
        $$renderer2.push("<!--[0-->");
        $$renderer2.push(`<div class="modal-footer">`);
        footer($$renderer2);
        $$renderer2.push(`<!----></div>`);
      } else {
        $$renderer2.push("<!--[-1-->");
      }
      $$renderer2.push(`<!--]--></div></div>`);
    } else {
      $$renderer2.push("<!--[-1-->");
    }
    $$renderer2.push(`<!--]-->`);
  });
}
export {
  Modal as M
};
